<template>
  <div class="agreement">
    <IndexHeader />
    <div class="studyTextBox">
      <div class="Video_top">
        <div class="title">学习感悟</div>
        <div class="line"></div>
        <div class="line2"></div>
        <div class="sg_text">
            <div class="content">{{ content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import IndexHeader from "../../components/IndexHeader/TopBar";
import { ref, reactive } from 'vue'
import { kcGetfeeling } from '../../server/jigou/course'
import { useRoute,useRouter } from "vue-router";

const route = useRoute()
const content = ref()
const query = reactive({
  userId: route.query.uid,
  courseId: route.query.id
})
async function getList(){
  let res = await kcGetfeeling(query)
  if( res != false ){
    content.value = res
  }
}
getList()

</script>
<style scped>
.agreement{
    margin-top: 64px;
}
.content {
    background: #fff;
    border: 1px solid #cdcdcd;
    padding: 18px;
    margin-left: 42px;
    margin-top: 30px;
}
.line{
  margin-top: 30px;
}
</style>